export default {
  beacon: 'beacon',
  vendorsExchange: 'vendorsExchange',
  tsfInside: 'tsfInside',
  unknown: 'unknown',
};
